import styled from 'styled-components'

export const Icon = styled.img`
    height: 32px;
    width: 32px;
`
